import React from "react"
import { useParams } from "react-router-dom"
import PostPayoutResolver from "./PostPayoutResolver"
import PayoutDistributionView from "./PayoutDistributionView"

export const PayoutDistributionPage: React.FC = () => {
  const { payout_id, post_id } = useParams<{ payout_id?: string; post_id?: string }>()

  if (post_id) {
    return <PostPayoutResolver postId={post_id} />
  }

  return <PayoutDistributionView payoutId={payout_id as string} />
}

export default PayoutDistributionPage
